import { render } from "./FormManagement.vue?vue&type=template&id=666b6b8c&scoped=true"
import script from "./FormManagement.vue?vue&type=script&lang=js"
export * from "./FormManagement.vue?vue&type=script&lang=js"

import "./FormManagement.vue?vue&type=style&index=0&id=666b6b8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666b6b8c"]])

export default __exports__